import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * ErrorAlert Component
 *
 * Displays an alert message with a given severity, message, and an optional title.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {"error"|"success"|"warning"|"info"} props.type - The type of alert.
 * @param {string} props.message - The alert message.
 * @param {string} [props.title] - An optional title for the alert.
 * @returns {JSX.Element} The rendered ErrorAlert component.
 */
const ErrorAlert = ({ type, message, title }) => {
	return (
		<Alert severity={type} sx={{ mb: 2 }}>
			{title && <AlertTitle>{title}</AlertTitle>}
			{message}
		</Alert>
	);
};

ErrorAlert.propTypes = {
	type: PropTypes.oneOf(['error', 'success', 'warning', 'info']).isRequired,
	message: PropTypes.string.isRequired,
	title: PropTypes.string,
};

ErrorAlert.defaultProps = {
	title: '',
};

export default ErrorAlert;
